<ng-container *ngIf="modeloVista && modeloVista.length > 0">
    <div class="row">
        <div class="col-sm-12">
            <button type="button" class="btn btn-sm btn-primary float-right mx-4"
                title="Agregar o eliminar ruts a las entidades" (click)="abrirModal()">
                Agregar/Eliminar
            </button>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="modeloVista && modeloVista.length > 0">
    <ng-container *ngFor="let entidad of modeloVista; let i = index;">
        <div class="container-fluid my-3">
            <accordion [isAnimated]="true" class="m-0">
                <accordion-group [isOpen]="entidad.expandido" panelClass="m-0" #accGroupEntidad>
                    <span class="font-weight-bold" accordion-heading>
                        <i class="fa" [ngClass]="{'fa-angle-down': accGroupEntidad?.isOpen, 'fa-angle-right': !accGroupEntidad?.isOpen}"></i>
                        {{entidad?.nombre || entidad?.idEntidad}}
                    </span>

                    <ng-container *ngTemplateOutlet="tableV2Template; context: { $implicit: {
                        entidad: entidad, 
                        ruts: entidad?.ruts || [], 
                        rutsVisibles: entidad?.rutsVisibles || [],
                        isMalla: false,
                        idPag: 'pag-normal-' + entidad.idEntidad
                    } }">
                    </ng-container>

                    <ng-container *ngIf="entidad?.rutsMalla && entidad.rutsMalla.length > 0">
                        <ng-container *ngTemplateOutlet="tableV2Template; context: { $implicit: {
                            entidad: entidad, 
                            ruts: entidad.rutsMalla, 
                            rutsVisibles: entidad?.rutsMallaVisibles || [],
                            isMalla: true,
                            idPag: 'pag-malla-' + entidad.idEntidad
                        } }">
                        </ng-container>
                    </ng-container>                  
            
                </accordion-group>
            </accordion>
        </div>
    </ng-container>
</ng-container>


<div class="row mt-5">
    <div class="col-sm-12 text-center">
        <button type="button" class="btn btn-sm btn-primary" (click)="avanzarFlujo()">
            Continuar
        </button>
    </div>
</div>

<ng-template #tableV2Template let-elemento>
    <div class="row d-flex justify-content-end my-2">
        <div class="col-sm-6 col-md-2">
            <div class="row">
                <div class="col-sm-12 d-flex justify-content-center">
                    Buscar Todos
                    <label class="switch switch-primary switch-sm ml-3">
                        <input type="checkbox" class="checkbox-buscar"
                            (change)="buscarTodosEntidad(elemento.rutsVisibles, $any($event.target).checked)"
                        >
                        <span></span>
                    </label>
                </div>
            </div>
        </div>

        <div class="col-sm-6 col-md-2">
            <div class="row">
                <div class="col-sm-12 d-flex justify-content-center">
                    Actualizar Todos
                    <label class="switch switch-primary switch-sm ml-3">
                        <input type="checkbox" class="checkbox-actualizar"
                            (change)="actualizarTodosEntidad(elemento.rutsVisibles, $any($event.target).checked)"
                        >
                        <span></span>
                    </label>
                </div>
            </div>
        </div>
    </div>

    <div class="row mb-3">
        <div class="col-sm-12 col-md-4"> 
            <div class="input-group">
                <input type="text" 
                    class="form-control" 
                    placeholder="Buscar rut en tabla..." 
                    [(ngModel)]="elemento.isMalla ? elemento.entidad.textoBusquedaMalla : elemento.entidad.textoBusquedaNormal"
                    (ngModelChange)="filtrarRutsBuscador(elemento.entidad, elemento.isMalla)"
                >
                <div class="input-group-append">
                    <span class="input-group-text bg-white text-muted">
                        <i class="fa fa-search"></i>
                    </span>
                </div>
            </div>
        </div>
    </div>

    <!--tabla entidad-->
    <div class="row table-height">
        <div class="col-sm-12">

            <div class="table-responsive py-3">
                <table class="table table-hover table-bordered border">
                    <thead>
                        <tr *ngIf="elemento?.isMalla">
                            <th colspan="100%" class="font-weight-bold bg-primary text-center align-middle th-atributo">
                                <span>
                                    Rut's Asociados
                                </span>
                            </th>
                        </tr>
                        <tr>
                            <th scope="col" rowspan="2" class="bg-primary th-head-size">
                                <div class="row">
                                    <div class="col-sm-12">
                                        <div class="row">
                                            <div class="col-sm-12 d-flex justify-content-center">
                                                <div class="row">
                                                    <div class="col-sm-12 text-center cursor-pointer mb-1" 
                                                        (click)="ordenarPorHabilitado(elemento.entidad, elemento?.isMalla)">
                                                        Habilitar/Deshabilitar
                                                        <div class="float-right ml-2 d-inline-block">
                                                            <i class="fa fa-caret-up d-block" 
                                                            [class.text-dark]="(elemento.isMalla ? elemento.entidad.ordenColumnaMalla : elemento.entidad.ordenColumnaNormal) === 'habilitado' && (elemento.isMalla ? elemento.entidad.ordenAscendenteMalla : elemento.entidad.ordenAscendenteNormal)">
                                                            </i>
                                                            <i class="fa fa-caret-down d-block" 
                                                            [class.text-dark]="(elemento.isMalla ? elemento.entidad.ordenColumnaMalla : elemento.entidad.ordenColumnaNormal) === 'habilitado' && !(elemento.isMalla ? elemento.entidad.ordenAscendenteMalla : elemento.entidad.ordenAscendenteNormal)">
                                                            </i>
                                                        </div>
                                                    </div>

                                                    <div class="col-sm-12 d-flex justify-content-center my-4">
                                                        <label class="switch switch-primary switch-sm">
                                                            <input type="checkbox" class="checkbox-actualizar"
                                                                (change)="habilitarTodosEntidad(elemento.ruts, elemento.rutsVisibles, $any($event.target).checked)">
                                                            <span></span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </th>

                            <th scope="col" rowspan="2" class="text-center align-middle font-weight-bold bg-primary cursor-pointer"
                                (click)="ordenarTabla(elemento.entidad, 'rut', elemento.isMalla)">
                                <span>Rut</span>
                                <div class="float-right ml-2 d-inline-block">
                                    <i class="fa fa-caret-up d-block" 
                                    [class.text-dark]="(elemento.isMalla ? elemento.entidad.ordenColumnaMalla : elemento.entidad.ordenColumnaNormal) === 'rut' && (elemento.isMalla ? elemento.entidad.ordenAscendenteMalla : elemento.entidad.ordenAscendenteNormal)">
                                    </i>
                                    <i class="fa fa-caret-down d-block" 
                                    [class.text-dark]="(elemento.isMalla ? elemento.entidad.ordenColumnaMalla : elemento.entidad.ordenColumnaNormal) === 'rut' && !(elemento.isMalla ? elemento.entidad.ordenAscendenteMalla : elemento.entidad.ordenAscendenteNormal)">
                                    </i>
                                </div>
                            </th>

                            <th scope="col" rowspan="2" class="text-center align-middle font-weight-bold bg-primary cursor-pointer" 
                                *ngFor="let cabecera of elemento.entidad.cabecerasAtributos"
                                (click)="ordenarTabla(elemento.entidad, cabecera.key, elemento.isMalla)">
                                <span>{{ cabecera.nombre }}</span>
                                <div class="float-right ml-2 d-inline-block">
                                    <i class="fa fa-caret-up d-block" 
                                    [class.text-dark]="(elemento.isMalla ? elemento.entidad.ordenColumnaMalla : elemento.entidad.ordenColumnaNormal) === cabecera.key && (elemento.isMalla ? elemento.entidad.ordenAscendenteMalla : elemento.entidad.ordenAscendenteNormal)">
                                    </i>
                                    <i class="fa fa-caret-down d-block" 
                                    [class.text-dark]="(elemento.isMalla ? elemento.entidad.ordenColumnaMalla : elemento.entidad.ordenColumnaNormal) === cabecera.key && !(elemento.isMalla ? elemento.entidad.ordenAscendenteMalla : elemento.entidad.ordenAscendenteNormal)">
                                    </i>
                                </div>
                            </th>

                            <th scope="col" class="text-center align-middle font-weight-bold bg-primary" 
                                *ngFor="let servicio of elemento.entidad.cabecerasServicios">
                                {{ servicio.nombre }}
                            </th>
                        </tr>
                        <tr>
                            <th scope="col" class="th-btn-head" 
                                *ngFor="let servicio of elemento.entidad.cabecerasServicios">
                                <div class="row">
                                    <div class="col-sm-12 col-md-6" *ngIf="servicio.permiteBuscar == true">
                                        <div class="row">
                                            <div class="col-sm-12 text-center">
                                                Buscar Todos
                                            </div>
                                            <div class="col-sm-12 d-flex justify-content-center">
                                                <label class="switch switch-primary switch-sm">
                                                    <input type="checkbox" class="checkbox-buscar"
                                                        (change)="buscarTodosPorServicio(elemento.rutsVisibles, servicio.idServicio, $any($event.target).checked)"
                                                    >
                                                    <span></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-12 col-md-6" *ngIf="servicio.permiteActualizar == true">
                                        <div class="row">
                                            <div class="col-sm-12 text-center">
                                                Actualizar Todos
                                            </div>
                                            <div class="col-sm-12 d-flex justify-content-center">
                                                <label class="switch switch-primary switch-sm">
                                                    <input type="checkbox" class="checkbox-actualizar"
                                                        (change)="actualizarTodosPorServicio(elemento.rutsVisibles, servicio.idServicio, $any($event.target).checked)"
                                                    >
                                                    <span></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-template #sinRuts>
                            <tr>
                                <td colspan="100%">
                                    Sin ruts en la entidad
                                </td>
                            </tr>
                        </ng-template>

                        <ng-container *ngIf="elemento?.rutsVisibles && elemento?.rutsVisibles.length > 0 else sinRuts">
                            <!--listado de ruts-->
                            <tr *ngFor="let item of elemento?.rutsVisibles| paginate: { 
                                    id: elemento.idPag, 
                                    itemsPerPage: 10, 
                                    currentPage: elemento.isMalla ? elemento.entidad.paginaMalla : elemento.entidad.paginaNormal 
                                }"
                            >
                                <td class="align-middle td-btn-head text-center">
                                    <label class="switch switch-primary switch-sm">
                                        <input type="checkbox" class="checkbox-actualizar"
                                            [(ngModel)]="item.filaHabilitada"
                                            (ngModelChange)="toggleFilaIndividual(item, elemento.ruts, $event)"
                                        >
                                        <span></span>
                                    </label>
                                </td>
                                <th class="align-middle text-nowrap" scope="row"
                                    (click)="graphMallaSocietaria && graphMallaSocietaria.length > 0 ? showMalla(elemento.entidad.idEntidad, item.rut) : null"
                                    [ngClass]="item?.consultadoCompletamente ? 'bg-consulted' : ''"
                                    [class.cursor-pointer]="graphMallaSocietaria && graphMallaSocietaria.length > 0"
                                >
                                    {{item.rut || '' | rutFormat}}
                                </th>
                                <td class="align-middle" 
                                    [ngClass]="item?.consultadoCompletamente ? 'bg-consulted' : ''"
                                    *ngFor="let atributo of item.atributosDinamicos"
                                >
                                    <ng-template #notNumber>
                                        {{ atributo.value }}
                                    </ng-template>
                                    <ng-container *ngIf="atributo?.typeAttribute === 'Number' || isNumber(atributo?.value) === true else notNumber">
                                        {{ atributo.value | number: '1.0-2' }}
                                    </ng-container>
                                </td>
                                <ng-container *ngFor="let servicio of item.servicios">
                                    <td class="align-middle" 
                                        [ngClass]="servicio?.estadoConsulta != 'sin_consultar' ? 'bg-consulted' : ''"
                                    >
                                        <div class="row">
                                            <div [ngClass]="servicio?.estadoConsulta != 'sin_consultar' ? 'col-md-5' : 'col-sm-12'">
                                                <div class="row">
                                                    <div [ngClass]="servicio?.estadoConsulta != 'sin_consultar' ? 'col-sm-12' : 'col-sm-12 col-md-6'" *ngIf="servicio?.permiteBuscar == true">
                                                        <div class="row">
                                                            <div class="col-sm-12 text-center">
                                                                Buscar
                                                            </div>
                                                            <div class="col-sm-12 d-flex justify-content-center">
                                                                <label class="switch switch-primary switch-sm">
                                                                    <input type="checkbox" class="checkbox-buscar"
                                                                        [(ngModel)]="servicio.buscarSeleccionado"
                                                                        (ngModelChange)="toggleServicioIndividual(item, servicio, 'buscar', $event)"
                                                                        [disabled]="!item.filaHabilitada"
                                                                    >
                                                                    <span></span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div [ngClass]="servicio?.estadoConsulta != 'sin_consultar' ? 'col-sm-12' : 'col-sm-12 col-md-6'" *ngIf="servicio?.permiteActualizar == true">
                                                        <div class="row">
                                                            <div class="col-sm-12 text-center">
                                                                Actualizar
                                                            </div>
                                                            <div class="col-sm-12 d-flex justify-content-center">
                                                                <label class="switch switch-primary switch-sm">
                                                                    <input type="checkbox" class="checkbox-actualizar"
                                                                        [(ngModel)]="servicio.actualizarSeleccionado"
                                                                        (ngModelChange)="toggleServicioIndividual(item, servicio, 'actualizar', $event)"
                                                                        [disabled]="!item.filaHabilitada"
                                                                    >
                                                                    <span></span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-12 col-md-7 d-flex align-items-center" *ngIf="servicio?.estadoConsulta !== 'sin_consultar'">
                                                <div class="row text-center">
                                                    
                                                    <div class="col-sm-12" *ngIf="servicio?.estadoConsulta === 'sin_info'">
                                                        <span class="badge badge-pill badge-warning" title="Sin información histórica disponible">
                                                            <i class="fa fa-exclamation" aria-hidden="true"></i>
                                                        </span>
                                                    </div>

                                                    <ng-container *ngIf="servicio?.estadoConsulta === 'ok'">
                                                        <div class="col-sm-12">
                                                            <span class="badge badge-pill badge-success">
                                                                <i class="fa fa-check" aria-hidden="true"></i>
                                                            </span>
                                                        </div>
                                                        <div class="col-sm-12 mt-1" *ngIf="servicio?.fechaReporte">
                                                            <span class="badge badge-info">
                                                                {{ servicio.fechaReporte | date: 'dd-MM-YYYY' }}
                                                            </span>
                                                        </div>
                                                    </ng-container>

                                                    <ng-container *ngIf="servicio?.estadoConsulta === 'error'">
                                                        <div class="col-sm-12">
                                                            <span class="badge badge-pill badge-danger" [title]="servicio.mensajeError">
                                                                <i class="fa fa-times" aria-hidden="true"></i>
                                                            </span>
                                                        </div>
                                                        <div class="col-sm-12 mt-2">
                                                            <button class="btn btn-primary btn-sm button-reconsultar" 
                                                                    title="Reconsultar"
                                                                    (click)="reconsultar(elemento.entidad.idEntidad, item.rut, servicio.idServicio)">
                                                                <i class="fa fa-refresh" aria-hidden="true"></i>
                                                            </button>
                                                        </div>
                                                    </ng-container>

                                                    <div class="col-sm-12 mt-1">
                                                        <button class="btn p-0" title="Borrar" 
                                                                (click)="borrarServicio(elemento.entidad.idEntidad, item.rut, servicio.idServicio)">
                                                            <i class="fa fa-trash text-danger"></i>
                                                        </button>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </ng-container>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </div>

            <div class="row mt-2" *ngIf="elemento?.rutsVisibles && elemento?.rutsVisibles.length > 0">
                <div class="col-sm-12 d-flex justify-content-end">
                    <pagination-controls 
                        [id]="elemento.idPag"
                        (pageChange)="elemento.isMalla ? elemento.entidad.paginaMalla = $event : elemento.entidad.paginaNormal = $event"
                        previousLabel="Anterior"
                        nextLabel="Siguiente">
                    </pagination-controls>
                </div>
            </div>

        </div>

        <div class="col-sm-12 d-flex justify-content-center mt-3 mb-5" *ngIf="elemento?.ruts && elemento?.ruts.length > 0">
            <button class="btn btn-primary"
                (click)="consultar(elemento?.entidad?.idEntidad, elemento.ruts)"
            >
                {{elemento.isMalla ? 'Consultar Asociados' : 'Consultar'}}
            </button>
        </div>
    </div>
</ng-template>
